import { Injectable } from '@angular/core';
import { HeaderColumn } from '../model/header-column.model';
import { StartupConfiguration } from '../model/startup-configuration';
import { Incident } from '../model/incident.model';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private webServiceUrl;
  private webServiceUrlParameterKey = 'webServiceUrl';
  private startupConfiguration: StartupConfiguration;

  static sortGridHeaders(headerColumn1: HeaderColumn, headerColumn2: HeaderColumn): number {
    if (headerColumn1.Ordinal > headerColumn2.Ordinal) {
      return 1;
    }
    if (headerColumn1.Ordinal < headerColumn2.Ordinal) {
      return -1;
    }
    return 0;
  }

  constructor() {
  }

  static getParameterByName(name: string, url?: string): string {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static getContentHeight(): string {
    return 'calc(100vh - 240px)';
  }

  static getLoadPanelShadeColor(): string {
    return 'rgba(0,0,0,0.4)';
  }

  /*------------ we augment the built-in encodeURIComponent because it does not encode characters  !, ', (, ), and * -----------*/
  encodeRFC3986URIComponent(text: string): string {
    return encodeURIComponent(text).replace(
      /[!'()*]/g,
      (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
    );
  }

  readEntryParameters(): void {
    this.readWebServiceUrlParameter();
  }

  getWebServiceRootUrl(): string {
    return this.webServiceUrl !== null ? this.webServiceUrl : this.startupConfiguration.webServiceUrl;
  }

  getWebServiceApiUrl(): string {
    return this.webServiceUrl !== null ? `${this.webServiceUrl}/api` : `${this.startupConfiguration.webServiceUrl}/api`;
  }

  getStartupConfiguration(): StartupConfiguration {
    return this.startupConfiguration;
  }

  setStartupConfiguration(configuration: StartupConfiguration): void {
    this.startupConfiguration = configuration;
  }

  getValueCopyingIncidentProxy(incident: Incident, valueMappingConfiguration: Map<string, string>): Incident {
    const incidentObject: Incident = incident;
    const setInterceptor = (propertyName: string | symbol, originalPropertyOldValue: any, originalPropertyNewValue: any) => {
      const propertyToMapValue = valueMappingConfiguration.get(propertyName.toString());
      if (propertyToMapValue) {
        const targetPropertyCurrentValue = incident[propertyToMapValue];
        const copyValueToMappedProperty = targetPropertyCurrentValue === undefined ||
          targetPropertyCurrentValue === null || targetPropertyCurrentValue?.toString().trim() === '' || originalPropertyOldValue === targetPropertyCurrentValue;
        if (copyValueToMappedProperty) {
          incident[propertyToMapValue] = originalPropertyNewValue;
        }
      }
    };
    return new Proxy(incidentObject, {
      set(target, property, newValue): boolean {
        const oldValue = target[property];
        target[property] = newValue;
        setInterceptor(property, oldValue, newValue);
        return true;
      }
    });
  }

  private readWebServiceUrlParameter(): void {
    this.webServiceUrl = HelperService.getParameterByName(this.webServiceUrlParameterKey);
    if (this.webServiceUrl === null) {
      this.webServiceUrl = sessionStorage.getItem(this.webServiceUrlParameterKey);
    } else {
      sessionStorage.setItem(this.webServiceUrlParameterKey, this.webServiceUrl);
    }
  }
}
